import React, { useState, useEffect } from 'react';
import { api } from '../../services/api';
import { Link, Navigate, useNavigate } from 'react-router-dom';
import Navbar from '../navbar/navbar';
import logoNfce from '../../images/nfce.png'
import logoRecibo from '../../images/recibo.png'
import nfeCancelada from '../../images/nfeCancelada.png';
import nfeExcl from '../../images/nfeExcl.png';
import contigencia from '../../images/contigencia.png';
import { vhostV1 } from '../funcoes';
import BuscaVazaia from '../components/buscavazia/buscaVazia';
import PedidosPdf from '../reports/pedidos/sinteticos';
import VendasPorFinalizadora from '../home/VendasPorFinalizadora';
import VendasPorCupom from '../reports/vendas/vendasporcupom';
import Loading from '../components/loading/Loading';
import SweetAlert from 'react-bootstrap-sweetalert';
import CupomFiscal from '../reports/nfe/CupomFiscal';
import cupom from '../reports/nfe/venda';
import { pdfjs } from 'react-pdf';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import Widget from '../components/widget/widget';
import customizeScrollbar from "customsb";
import SRI_pagination from '../components/pagination/pagination';
import VendasProdutoPDF from '../reports/pedidos/relProdutos';
import gerarNotaFiscal from '../reports/pedidos/notaBalcao';
import FooterBar from '../footer/footerBar';
import axios from 'axios';
import JSZip from "jszip";
import { saveAs } from "file-saver";
import GerarCarne from '../reports/vendas/gerarCarne';
import { gerarDuplicatas } from '../reports/vendas/gerarDuplicata';
import imprimirEncomenda from '../reports/encomendas/imprimeEncomenda';
import imprimirRelatorioPdf from '../reports/encomendas/encomendasPdfRelatorio';


pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;




function ListaEncomendas() {  


     const [pedidos,setPedidos] = useState([]); 
     const [sResult,setSresult] = useState(0);
     const [tpRelatorio,setTipoRelatorio] = useState(0);
  
     const [load,setLoad] = useState(false);
     const [confirmaEmissao,setConfirmaEmissao] = useState(false);
     const [erroEmissao,setErroEmissao] = useState(false);
     const [base64Data, setBase64Data] = useState('');
     const [numPages, setNumPages] = useState(null);
     const [msgErro,setmsgErro] = useState('');
     const [caixasDisponiveis, setCaixasDisponiveis] = useState([]);
     const [nPedido, setNPedido] = useState(0);
     const [reload, setReload] = useState(false);
     const [cancelada, setCancelada] = useState(false);
     const [msgResponse, setMsgResponse] = useState('');
     const [nPedidoSelecionado, setNPedidoSelecionado] = useState("");
     const [confirmaCancelamento, setConfirmaCancelamento] = useState(false);
     const [confirmaCancelamentoVenda, setConfirmaCancelamentoVenda] = useState(false); 
     const [selectRelatorio, setSelectRelatorio] = useState(false);
     const [codVendaSelecionado, setCodVendaSelecionado] = useState("");
     const [documentoSelecionado, setDocumentoSelecionado] = useState("");
     const [progressoXml, setProgressoXml] = useState(0);
     const [totalXml, setTotalXml] = useState(0);
     const [busca, setBusca] = useState("");
      const [status, setStatus] = useState(0);
      const [dataPedidoInicial, setDataPedidoInicial] = useState(new Date());
      const [dataPedidoFinal, setDataPedidoFinal] = useState(new Date());
      const [dataEntregaInicial, setDataEntregaInicial] = useState(new Date());
      const [dataEntregaFinal, setDataEntregaFinal] = useState(new Date());
      const [usaDataPedido, setUsaDataPedido] = useState(false);
const [usaDataEntrega, setUsaDataEntrega] = useState(false);
const [att, setAtt] = useState(false);

     const [encomendas, setEncomendas] = useState([]);

     function hojeFormatado() {
  return new Date().toISOString().substring(0, 10);
}

     const [dataInical, setDataInicial] = useState(() => {
  const saved = localStorage.getItem('dataInicial');
  return saved ? saved : hojeFormatado() + 'T10:10:00.000Z';
});

const [dataFinal, setDataFinal] = useState(() => {
  const saved = localStorage.getItem('dataFinal');
  return saved ? saved : hojeFormatado() + 'T10:10:00.000Z';
});

const [tipo, setTipo] = useState(() => {
  return localStorage.getItem('tipo') || 'TODOS';
});

const [caixa, setCaixa] = useState(() => {
  return localStorage.getItem('caixa') || '%';
});

const [nPag, setnPag] = useState(() => {
  return localStorage.getItem('nPag') || 1;
});

const [totalPaginas, setTotalPaginas] = useState(() => {
  return localStorage.getItem('totalPaginas') || 1;
});

useEffect(() => {
  localStorage.setItem('dataInicial', dataInical);
}, [dataInical]);

useEffect(() => {
  localStorage.setItem('dataFinal', dataFinal);
}, [dataFinal]);

useEffect(() => {
  localStorage.setItem('tipo', tipo);
}, [tipo]);

useEffect(() => {
  localStorage.setItem('caixa', caixa);
}, [caixa]);

useEffect(() => {
  localStorage.setItem('nPag', nPag);
}, [nPag]);

useEffect(() => {
  localStorage.setItem('totalPaginas', totalPaginas);
}, [totalPaginas]);


     if(reload === true){
      window.location.reload();
      setReload(false);
     }

     const onDocumentLoadSuccess = ({ numPages }) => {
       setNumPages(numPages);
     };

     function handlePageChange(value){
      if(value === "&laquo;" || value === '... '){
        setnPag(1);
      }else if (value === "&lsaquo;" ){
        if (nPag !== 1){
          setnPag(nPag-1);
        }
      }else if(value === "&rsaquo;"){
        setnPag(nPag+1);        
      }else if(value === "&raquo;" || value === ' ...' ){
        setnPag(totalPaginas);        
      }else{
        setnPag(value);
      }    
     
     }
       

    let config = {
      headers: {
         'Authorization': localStorage.getItem("token")
         }
      }

      let config2 = {
        headers: {
           'Authorization': localStorage.getItem("token2")
           }
        }


      async function fetchBase64Data(schave){
        try {
          setLoad(true)
            const response = await api.post(vhostV1('webcash/nfe/danfepdf'),{
            loja: localStorage.getItem('loja'),
            empresa: 0,
            chave:schave
          },config);
          setLoad(false)
          console.log(response)
          setBase64Data(response.data.dados.data.base64);
          convertAndOpenPDF(response.data.dados.data.base64);
        } catch (error) {
          console.error('Erro ao buscar base64 da API:', error);
        }
      };

      const convertAndOpenPDF = (base64String) => {
        const byteCharacters = atob(base64String);
        const byteArrays = [];
    
        for (let offset = 0; offset < byteCharacters.length; offset += 512) {
          const slice = byteCharacters.slice(offset, offset + 512);
    
          const byteNumbers = new Array(slice.length);
          for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
          }
    
          const byteArray = new Uint8Array(byteNumbers);
          byteArrays.push(byteArray);
        }
    
        const pdfBlob = new Blob(byteArrays, { type: 'application/pdf' });
        const pdfUrl = URL.createObjectURL(pdfBlob);
    
        window.open(pdfUrl, '_blank');
      };

           // Aplicando a personalização com opções diferentes
// Abaixo é somente um exemplo de personalização, adapte para o seu projeto
useEffect(() => {
  // O uso do useEffect garante que a função seja chamada apenas no lado do cliente
  customizeScrollbar({
    scrollbarWidth: "10px",
    trackBackground: "#333",
    thumbBackground:
      "linear-gradient(178.8deg, #ffa066 47.41%, #ff9666 65.18%, #ff783a 90.84%)",
    thumbBorderRadius: "10px",
  });
}, []);

function formatarData(dataIso) {
  const data = new Date(dataIso);
  const dia = String(data.getDate()).padStart(2, '0');
  const mes = String(data.getMonth() + 1).padStart(2, '0'); // mês começa do 0
  const ano = data.getFullYear();

  return `${dia}/${mes}/${ano}`;
}

useEffect(function(){
    
  api.post(vhostV1('webcash/caixa/configCaixa'),{},config)
    .then(function (response) {
      console.log(response);
      
      const caixas = response.data.dados;
      setCaixasDisponiveis(caixas);
                                  
               
    })
    .catch(function (error) {
     
      console.log(error);

              
    });

    
  },[])

  const getDadosEmpresa = async() =>{
    let response = {};
    try {
      response = await  api.post(vhostV1('webcash/Empresa/retornaEmpresa'),{},config)
    } catch(error){
      console.log(error);
      
    }
    console.log(response.data.dados);

    return response.data.dados;
    
  }


 
     const getDadosVenda = async(cod)=>{
      console.log(cod);
      
      let response = {};
      try {
        response = await api.post(vhostV1('webcash/vendas/retornaVenda/'+cod),{},config);

        
      } catch(error) {
        console.log(error);
        
      }
      console.log(response.data.dados);
      
      return response.data.dados;
     }

      const getDadosRelatorio = async()=>{
        
        console.log({dtinicial:dataInical,
            dtfinal:dataFinal,
            Stipo:tipo,
            sCaixa:caixa});
        let response = {};
        try {
          response = await api.post(vhostV1('webcash/vendas/relSintetico'),{
            loja: localStorage.getItem('loja'),
            empresa: 0,
           //dtinicial:"2023-02-13T13:45:00.000Z",
            dtInicial:dataInical,
            dtFinal:dataFinal,
            Stipo:tipo,
            sCaixa:caixa
          }, config)
          ;
          
          
          
        } catch (error) {
          console.log(error);          
        }
        console.log(response); 
        return response.data.dados;
      
        //setItens(response.data.dados); 
        //setResultItens(response.data.result)     
      
      }

       const getDadosEncomenda = async(cod)=>{
        
       
        let response = {};
        try {
          response = await api.post(vhostV1('webcash/encomendas/buscarEncomenda/'+cod),{},config)
          ;
          
          
          
        } catch (error) {
          console.log(error);          
        }
        console.log(response); 
        return response.data;
      
          
      
      }




      const getDadosRelatorioFinalizadora = async()=>{
        
        
        
        let response = {};
        try {
          response = await api.post(vhostV1('webcash/vendas/listavendas/finalizadora'),{
            loja: localStorage.getItem('loja'),
            empresa: 0,
           //dtinicial:"2023-02-13T13:45:00.000Z",
            dtInicial:dataInical,
            dtFinal:dataFinal,
            Stipo:tipo,
            sCaixa:caixa
          }, config)
          
        } catch (error) {
          console.log(error);          
        }
         console.log(response);
         
        return response.data.dados;
      
        //setItens(response.data.dados); 
        //setResultItens(response.data.result)             
      
      }

      const getDadosRelatorioProduto = async()=>{
        let response = {};
        try {
          response = await api.post(vhostV1('webcash/dashboard/produtoMaisVendido'),{
            loja: localStorage.getItem('loja'),
            empresa: 0,
            dataInicial: dataInical,
            dataFinal: dataFinal,
        }, config)}
        
        catch (error) {
          console.log(error);          
        }
         console.log(response);
         
         
        return response.data.dados; }
      

      const getDadosRelatorioCupom = async()=>{
        
        let response = {};
        try {
          response = await api.post(vhostV1('webcash/vendas/relitens'),{
            loja: localStorage.getItem('loja'),
            empresa: 0,
           //dtinicial:"2023-02-13T13:45:00.000Z",
            dtInicial:dataInical,
            dtFinal:dataFinal,
            tipo:tipo,
            caixa:caixa
          }, config)
          
        } catch (error) {
          console.log(error);          
        }
         console.log(response);
         
         
        return response.data.dados;
      
        //setItens(response.data.dados); 
        //setResultItens(response.data.result)
             
      
      }

     async function imprimirEntregaDetail(cod){
        const tItens = await getDadosEncomenda(cod);
        console.log(tItens);
        imprimirEncomenda({idVenda: tItens.COD_ORCAMENTO, dataEntrega: formatarDataBR(tItens.DATA_ENTREGA), saborTorta: tItens.SABOR_TORTA, itens: tItens.itens, infoPag: tItens.INFO_PAG});
     }

      

     async function gerarNotaBalcao(cod) {
      const tItens = await getDadosVenda(cod);
      console.log(tItens);
      const tEmpresa = await getDadosEmpresa();

      gerarNotaFiscal(tItens, tEmpresa);
      
     }

     async function buscarContasEGerarCarne(documento) {

  try {

    const response = await api.post(
      vhostV1('webcash/contas'),
      {
        loja: localStorage.getItem('loja'),
        empresa: 0,
        documento: String(documento), // 🔥 usa o documento aqui
        tipo: "R",
        colaborador: 0
      },
      config
    );

    console.log(response);
    

    const contas = response?.data?.dados || [];

    // 🔥 Filtra apenas contas com DOCUMENTO igual
    const contasDoPedido = contas.filter(
      c => c.DOCUMENTO === String(documento) && c.CANCELADO !== "T"
    );

    if (!contasDoPedido.length) {
      alert("Nenhuma conta encontrada para este documento.");
      return;
    }

    // 🔥 Monta array no formato do GerarCarne
    const carnesFormatados = contasDoPedido.map(conta => ({

      empresa: "SUA EMPRESA AQUI", // pode pegar do getEmpresa()
      cnpj: "00.000.000/0001-00",

      titulo: conta.SEQ,
      documento: conta.DOCUMENTO,
      nossoNumero: conta.NOSSO_NUMERO,

      vencimento: new Date(conta.DATA_VENC).toLocaleDateString('pt-BR'),
      emissao: new Date(conta.DATA_EMISSAO).toLocaleDateString('pt-BR'),

      valor: Number(conta.VALOR || 0),
      desconto: Number(conta.DESCONTO || 0),
      juros: Number(conta.JUROS || 0),
      multa: Number(conta.MULTA || 0),

      sacadoCodigo: conta.RESPONSAVEL,
      sacadoNome: conta.RAZAO,

      linhaDigitavel: conta.DESCRICAO || ''
    }));

    console.log(carnesFormatados);
    const contasFormatadas = formatarContasParaDuplicata(contas);
    console.log(contasFormatadas);
    
    // 🔥 Envia para o PDF
    await GerarCarne(carnesFormatados, contasFormatadas);

    

    

  } catch (error) {
    console.error(error);
    alert("Erro ao buscar contas.");
  }
}

function formatarMoedaBR(valor) {
  return Number(valor).toLocaleString("pt-BR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
}

function valorPorExtenso(valor) {
  const unidades = [
    "", "UM", "DOIS", "TRÊS", "QUATRO", "CINCO", "SEIS",
    "SETE", "OITO", "NOVE", "DEZ", "ONZE", "DOZE",
    "TREZE", "QUATORZE", "QUINZE", "DEZESSEIS",
    "DEZESSETE", "DEZOITO", "DEZENOVE"
  ];

  const dezenas = [
    "", "", "VINTE", "TRINTA", "QUARENTA",
    "CINQUENTA", "SESSENTA", "SETENTA",
    "OITENTA", "NOVENTA"
  ];

  const centenas = [
    "", "CENTO", "DUZENTOS", "TREZENTOS",
    "QUATROCENTOS", "QUINHENTOS",
    "SEISCENTOS", "SETECENTOS",
    "OITOCENTOS", "NOVECENTOS"
  ];

  function converterMenorQueMil(n) {
    if (n === 0) return "";
    if (n === 100) return "CEM";
    if (n < 20) return unidades[n];

    let c = Math.floor(n / 100);
    let d = Math.floor((n % 100) / 10);
    let u = n % 10;

    let texto = "";

    if (c) {
      texto += centenas[c];
      if (n % 100) texto += " E ";
    }

    if (d < 2) {
      texto += unidades[d * 10 + u];
    } else {
      texto += dezenas[d];
      if (u) texto += " E " + unidades[u];
    }

    return texto;
  }

  function converter(n) {
    if (n < 1000) return converterMenorQueMil(n);

    let milhar = Math.floor(n / 1000);
    let resto = n % 1000;

    let texto = "";

    if (milhar === 1) {
      texto = "MIL";
    } else {
      texto = converterMenorQueMil(milhar) + " MIL";
    }

    if (resto > 0) {
      if (resto < 100) {
        texto += " E ";
      } else {
        texto += " ";
      }
      texto += converterMenorQueMil(resto);
    }

    return texto;
  }

  const inteiro = Math.floor(valor);
  const centavos = Math.round((valor - inteiro) * 100);

  let resultado = converter(inteiro) + " REAIS";

  if (centavos > 0) {
    resultado += " E " + converterMenorQueMil(centavos) + " CENTAVOS";
  }

  return resultado;
}

function formatarDataBR(data) {
  if (!data) return null;

  const d = new Date(data);

  const dia = String(d.getDate()).padStart(2, '0');
  const mes = String(d.getMonth() + 1).padStart(2, '0');
  const ano = d.getFullYear();

  return `${dia}/${mes}/${ano}`;
}

function formatarContasParaDuplicata(contas) {
  if (!contas || contas.length === 0) return null;

  const primeira = contas[0];
  const ultima = contas[contas.length - 1];

  const totais = contas.reduce(
    (acc, conta) => {
      acc.valor += Number(conta.VALOR || 0);
      acc.juros += Number(conta.JUROS || 0);
      acc.multa += Number(conta.MULTA || 0);
      acc.desconto += Number(conta.DESCONTO || 0);
      acc.totalPagar += Number(conta.TOTAL_PAGAR || 0);
      return acc;
    },
    {
      valor: 0,
      juros: 0,
      multa: 0,
      desconto: 0,
      totalPagar: 0,
    }
  );

  return {
    EMPRESA: primeira.EMPRESA,
    DOCUMENTO: primeira.DOCUMENTO,
    NOSSO_NUMERO: primeira.NOSSO_NUMERO,
    RESPONSAVEL: primeira.RESPONSAVEL,
    RAZAO: primeira.RAZAO,
    CNPJ: primeira.CNPJ,
    CIDADE: primeira.CIDADE,
    CEP: primeira.CEP,
    ENDERECO: primeira.ENDERECO,

    DATA_EMISSAO: formatarDataBR(primeira.DATA_EMISSAO),
    DATA_VENC: formatarDataBR(ultima.DATA_VENC),

    VALOR: totais.valor,
    JUROS: totais.juros,
    MULTA: totais.multa,
    DESCONTO: totais.desconto,
    TOTAL_PAGAR: formatarMoedaBR(totais.totalPagar),
    VALOR_EXTENSO: valorPorExtenso(totais.totalPagar),

    TIPO_CONTA: primeira.TIPO_CONTA,
    PARCELAS: contas.length
  };
}

async function gerarDuplicata(documento) {
  
  try {

    const response = await api.post(
      vhostV1('webcash/contas'),
      {
        loja: localStorage.getItem('loja'),
        empresa: 0,
        documento: String(documento), // 🔥 usa o documento aqui
        tipo: "R",
        colaborador: 0
      },
      config
    );

    console.log(response);
    

    const contas = response?.data?.dados || [];
    const contasFormatadas = formatarContasParaDuplicata(contas);

    await gerarDuplicatas(contasFormatadas);
  } catch (error) {
    console.error(error);}
  
}


      async function gerarRelatorio () { 

        if(Number(tpRelatorio) === 0 ){
        const tItens = await getDadosRelatorio();
        console.log(tItens);
         
        
          PedidosPdf(tItens);
        }else if(Number(tpRelatorio) === 1){
          
          const tItens = await getDadosRelatorioCupom();
          console.log(tItens);
          
          VendasPorCupom(tItens);
        }else if(Number(tpRelatorio) === 2){
          const tItens = await getDadosRelatorioProduto();
          console.log(tItens);


          VendasProdutoPDF(tItens);
        }
        else{
          const tItens = await getDadosRelatorioFinalizadora();
          VendasPorFinalizadora(tItens);
          console.log(tItens);
          
        }      
               
      }  

      async function imprimirRelatorioEncomenda(){
         const tItens = await getDadosRelatorioEncomendas();
         console.log(tItens);
         imprimirRelatorioPdf(tItens, {usaDataPedido, dataPedidoInicial, dataPedidoFinal, usaDataEntrega, dataEntregaInicial, dataEntregaFinal, status});
      }

     
      async function getDadosRelatorioEncomendas() {
  const sJson = {};

  sJson.loja = localStorage.getItem('loja');
  sJson.empresa = 0;

  // Busca tudo para o relatório
  sJson.pagina = 1;
  sJson.regPag = 99999;

  if (Number(status) > 0) {
    sJson.status = Number(status);
  }

  sJson.busca = busca || "";

  if (usaDataPedido) {
    sJson.data_pedido1 = dataPedidoInicial || "";
    sJson.data_pedido2 = dataPedidoFinal || "";
  }

  if (usaDataEntrega) {
    sJson.data_entrega1 = dataEntregaInicial || "";
    sJson.data_entrega2 = dataEntregaFinal || "";
  }

  try {
    const response = await api.post(
      vhostV1('webcash/encomendas'),
      sJson,
      config
    );

    return response.data.dados || [];

  } catch (error) {
    console.error(error);
  }
}


    function filtrarPedidos(){
      setLoad(true)
     
    const sJson = {}
    sJson.loja=localStorage.getItem('loja');
    sJson.empresa=0;
    sJson.pagina=Number(nPag);
    sJson.regPag=10;
 if (Number(status) > 0) {
  sJson.status = Number(status);
}
    sJson.busca=busca || "";
    if (usaDataPedido === true) {
      sJson.data_pedido1 = dataPedidoInicial || "";
      sJson.data_pedido2 = dataPedidoFinal || "";
    }
    if (usaDataEntrega === true) {
      sJson.data_entrega1 = dataEntregaInicial || "";
      sJson.data_entrega2 = dataEntregaFinal || "";
    }
  console.log(sJson);
  api.post(
    vhostV1('webcash/encomendas'),
    sJson,
    config
  )
  .then(function (response) {

    console.log(response);
    setLoad(false);

    setTotalPaginas(response.data.quantidadeDePaginas);

    if (Array.isArray(response.data.dados)) {
      setEncomendas(response.data.dados);
    }

    setSresult(response.data.result);

  })
  .catch(function (error) {

    console.log(error);

  });

} 



  

    function imprimirNota(){

      CupomFiscal(cupom);

    }


    async function EmitirNFCe (e,tipo) { 
      setLoad(true)
      
      const tItens = await enviarNFce(e,tipo);    
      //console.log('retorno '+tItens);
      
      filtrarPedidos();
      
        
    }

    function handleCancelamento(e){
      setNPedidoSelecionado(e);
      setConfirmaCancelamento(true);
    }

    function handleCancelamentoVenda(codVenda, doc){
      setCodVendaSelecionado(codVenda);
      setDocumentoSelecionado(doc);
      setConfirmaCancelamentoVenda(true);
    }





    const enviarNFce = async(npedido,tipo)=>{
      setLoad(true)
      const sJson = {}
        sJson.loja=localStorage.getItem('loja'); 
        sJson.empresa=0;
        sJson.dav=String(npedido);
        sJson.tipo=tipo;
        sJson.tag=1;     
        console.log(sJson);
         
         const res = await api.post(vhostV1('webcash/nfe/emitir/nfe'), sJson, config)  
          console.log(res);
        
        if (res.status===200) {      
         filtrarPedidos(); 
         setConfirmaEmissao(true)       
        }else {
          setLoad(false)
          //filtrarPedidos();
          console.log(res);
          
          setmsgErro(res.response.data.detalhes);
          setErroEmissao(true)
        }      
     
    }

  

async function baixarTodosXml() {
  try {
    setLoad(true);
    setProgressoXml(0);

    // 1️⃣ Buscar todos os pedidos
    const response = await api.post(
      vhostV1('webcash/vendas/listar'),
      {
        loja: localStorage.getItem('loja'),
        empresa: 0,
        dataInicial: dataInical,
        dataFinal: dataFinal,
        tipo: tipo,
        caixa: caixa,
        pagina: 1,
        regPag: 100000
      },
      config
    );

    const pedidos = response.data?.dados || [];

    if (pedidos.length === 0) {
      setLoad(false);
      return;
    }

    // 2️⃣ Filtrar apenas pedidos com NFC-e válida
    const pedidosValidos = pedidos.filter(
      (p) => p.NFCE_STATUS === 100 || p.NFCE_STATUS === 9 || p.NFCE_STATUS === 150
    );

    setTotalXml(pedidosValidos.length);

    if (pedidosValidos.length === 0) {
      setLoad(false);
      return;
    }

    // 3️⃣ Criar ZIP
    const zip = new JSZip();
    let contador = 0;

    // 4️⃣ Baixar XMLs
    for (const pedido of pedidosValidos) {
      const chave = pedido.NFCE_CHAVE;
      if (!chave) continue;

      try {
        const res = await api.post(
          vhostV1(`webcash/nfe/baixarXmlUni/${chave}`),
          {},
          config
        );

        const xmlBase64 = res.data?.data?.xml_base64;
        if (!xmlBase64) continue;

        zip.file(`${chave}.xml`, atob(xmlBase64));

        contador++;
        setProgressoXml(contador);
      } catch (err) {
        // erro individual não quebra o loop
        console.error(`Erro ao baixar XML da chave ${chave}`, err);
      }
    }

    // 5️⃣ Gerar e baixar ZIP
    const zipBlob = await zip.generateAsync({ type: "blob" });
    saveAs(zipBlob, `xml_nfce.zip`);

  } catch (err) {
    console.error('Erro ao baixar XMLs', err);
  } finally {
    setLoad(false);
    setProgressoXml(0);
    setTotalXml(0);
  }
}



   useEffect(function () {
    const sJson = {}
    sJson.loja=localStorage.getItem('loja');
    sJson.empresa=0;
    sJson.pagina=Number(nPag);
    sJson.regPag=10;
    if(status !== 0){
    sJson.status=Number(status) || "";
  }
    sJson.busca=busca || "";
    if (usaDataPedido === true) {
      sJson.data_pedido1 = dataPedidoInicial || "";
      sJson.data_pedido2 = dataPedidoFinal || "";
    }
    if (usaDataEntrega === true) {
      sJson.data_entrega1 = dataEntregaInicial || "";
      sJson.data_entrega2 = dataEntregaFinal || "";
    }

  api.post(
    vhostV1('webcash/encomendas'),
    sJson,
    config
  )
  .then(function (response) {

    console.log(response);

    setTotalPaginas(response.data.quantidadeDePaginas);

    if (Array.isArray(response.data.dados)) {
      setEncomendas(response.data.dados);
    }

    setSresult(response.data.result);

  })
  .catch(function (error) {

    console.log(error);

  });

}, [att, nPag]);

    async function cencelaNFE(nfeChave) {

      
     
      const res = await api.post(vhostV1('webcash/nfe/cancelaNfe'), {
        loja: localStorage.getItem('loja'),
        empresa: 0,
        chave: nfeChave,
        tag: 1
      },config);
      console.log(res);
      if (res.data?.result === 1) {
        setMsgResponse(res.data.mensagem);
        setConfirmaCancelamento(false);
        setCancelada(true); 
        filtrarPedidos(); 
              
      } else {
        setmsgErro(res.data.mensagem);
        setErroEmissao(true)
      }
      

  }

  async function cancelaVenda(codVenda, doc) {

      
     
      const res = await api.post(vhostV1('webcash/vendas/cancelaVenda'), {
        codVenda: codVenda,
        documento: doc,
      },config);
      console.log(res);
      if (res.data?.result === 1) {
        setMsgResponse(res.data.message);
        setConfirmaCancelamentoVenda(false);
        setCancelada(true); 
        filtrarPedidos(); 
              
      } else {
        setConfirmaCancelamentoVenda(false);
        setmsgErro(res.data.error);
        setErroEmissao(true)
      }
      

  }
 

  const navigate = useNavigate();

  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event.key === "F1") {
        event.preventDefault(); 
        navigate("/app/encomendas/novaEncomenda");
      }
    };

    document.addEventListener("keydown", handleKeyPress);
    return () => {
      document.removeEventListener("keydown", handleKeyPress);
    };
  }, [navigate]);

  function podeCancelar(pedido) {
  if (!pedido.DATA || !pedido.HORA) return false;

  // Extrai apenas a hora da string HORA
  const horaUTC = new Date(pedido.HORA);
  const dataUTC = new Date(pedido.DATA);

  // Monta a data completa da venda em UTC
  const dataVendaUTC = new Date(Date.UTC(
    dataUTC.getUTCFullYear(),
    dataUTC.getUTCMonth(),
    dataUTC.getUTCDate(),
    horaUTC.getUTCHours(),
    horaUTC.getUTCMinutes(),
    horaUTC.getUTCSeconds()
  ));

  // Agora (UTC)
  const agoraUTC = new Date();

  // Diferença em horas
  const diffHoras = (agoraUTC - dataVendaUTC) / (1000 * 60 * 60);

  return diffHoras <= 24;
}
  
  

function isSameDay(dateStr) {
  const pedidoData = new Date(dateStr);
  const hoje = new Date();

  return (
    pedidoData.getUTCFullYear() === hoje.getFullYear() &&
    pedidoData.getUTCMonth() === hoje.getMonth() &&
    pedidoData.getUTCDate() === hoje.getDate()
  );
}

function alterarStatusEncomenda(cod, status) {
  api.post(vhostV1('webcash/encomendas/alterarStatusEncomenda'), {
    loja: localStorage.getItem('loja'),
    empresa: 0,
    status: Number(status),
    id: Number(cod)
  }, config)
  .then(function (response) {
    console.log(response);
    setAtt(!att);
    // Atualize a lista de encomendas ou faça outras ações necessárias
  })
  .catch(function (error) {
    console.log(error);
  });

}
 


      

    return <div>

        <Navbar/>
        <div className="container-fluid titulo offset-lg-1 col-lg-10">
        
       
        <div className="d-flex justify-content-between">
              <h1 className="d-inline">Encomendas</h1>
              <div>
                <Link type="button" className="btn btn-primary btn-cli"  to="/app/encomendas/novaEncomenda/0"><i className="bi bi-plus-circle-fill"></i> Encomenda <span className="shortcut">(F1)</span></Link>
                <button type="button" className="btn btn-secondary btn-cli" data-bs-toggle="modal" data-bs-target="#moda-filtro"><i className="bi bi-funnel-fill"></i>Filtros</button>
                <button
  id="botao-produto"
  className="btn btn-danger btn-cli mt-3"
  type="button"
  onClick={async () => await imprimirRelatorioEncomenda()}
>
  <i className="bi bi-printer-fill"></i> Relatório
</button>
                                
                {/*<button type="button" onClick={async()=> await gerarRelatorio()} className="btn btn-danger btn-cli" data-bs-dismiss="modal"><i className='bi bi-printer-fill'></i>Imprimir</button>
                {/*<button type="button" className="btn btn-danger btn-cli"  data-bs-toggle="modal" data-bs-target="#staticBackdrop"><i className="bi bi-printer-fill"></i> Relatório</button>
                <SalesReport/>*/}
              </div>
        </div> 
        
        <div className="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
            <div className="modal-dialog modal-sm">
              <div className="modal-content">
                <div className="modal-header">
                  <h1 className="modal-title fs-5" id="staticBackdropLabel">Relátorio de Encomendas</h1>
                  <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div className="modal-body">
                  <div className="contnt-modal">
                   <h5>Tipo do relatório </h5> 
                  <div className="form-check">
                    <input className="form-check-input" value={0}  type="radio" name="flexRadioDefault" id="flexRadioDefault1"/>
                    <label className="form-check-label" htmlFor="flexRadioDefault1">
                      Sintético
                    </label>
                  </div>
                 

                  <div className="form-check">
                    <input className="form-check-input" value={2}  type="radio" name="flexRadioDefault" id="flexRadioDefault2"/>
                    <label className="form-check-label" htmlFor="flexRadioDefault2">
                      Finalizadora
                    </label>
                  </div>

                    
                    <hr />

                   <div className="row">
                     <h5>Período  </h5>   
                       <div className="datas col-8 offset-2">
                         <input type="date" className='form-control'/>
                         <br />
                         <input type="date" className='form-control'/>
                         </div>
                          
                     </div>

                  </div>
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Fechar</button>
                              
                  { sResult === 1?
                  <div>                  
                  <button type="button" onClick={ async()=> await gerarRelatorio()} className="btn btn-primary btn-cli" data-bs-dismiss="modal">Imprimir</button>
                  </div>
                  :null} 
                  

                </div>
              </div>
            </div>
          </div>


          <div className="modal fade" id="moda-filtro" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h1 className="modal-title fs-5" id="staticBackdropLabel">Filtros</h1>
                  <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div className="modal-body">
                  <div className="contnt-modal">
                        
                    <hr />                      

                   <div className="row">
                    <div className="datas col-5">
  <h6>Datas Iniciais</h6>

  <div className="form-check form-switch">
    <input
      className="form-check-input"
      type="checkbox"
      checked={usaDataPedido}
      onChange={(e) => setUsaDataPedido(e.target.checked)}
    />
    <label className="form-check-label">
      Data do Pedido
    </label>
    <input
      type="date"
      value={dataPedidoInicial}
      onChange={(e) => setDataPedidoInicial(e.target.value)}
      className="form-control"
      disabled={!usaDataPedido}
    />
  </div>

  <div className="form-check form-switch mt-3">
    <input
      className="form-check-input"
      type="checkbox"
      checked={usaDataEntrega}
      onChange={(e) => setUsaDataEntrega(e.target.checked)}
    />
    <label className="form-check-label">
      Data de Entrega
    </label>
    <input
      type="date"
      value={dataEntregaInicial}
      onChange={(e) => setDataEntregaInicial(e.target.value)}
      className="form-control"
      disabled={!usaDataEntrega}
    />
  </div>
</div>

<div className="datas col-5">
  <h6>Datas Finais</h6>
  <label ></label>

  <div className="">
    <input
      type="date"
      value={dataPedidoFinal}
      onChange={(e) => setDataPedidoFinal(e.target.value)}
      className="form-control"
      disabled={!usaDataPedido}
    />
  </div>

  <label></label>
  <div className="mt-3">
    <input
      type="date"
      value={dataEntregaFinal}
      onChange={(e) => setDataEntregaFinal(e.target.value)}
      className="form-control"
      disabled={!usaDataEntrega}
    />
  </div>
</div>

                          
                     </div>
                     <br />

                    <div className="row">
  <div className="col-10">
    <label className="form-label">
      Status da Encomenda
    </label>

    <select
      className="form-select"
      value={status}
      onChange={(e) => setStatus(e.target.value)}
    >
      <option value={0}>Todos</option>
      <option value={1}>Pendente</option>
      <option value={2}>Entregue</option>
      <option value={3}>Cancelado</option>
    </select>
  </div>
</div>
                  


                   

                  </div>
                </div>
                <div className="modal-footer">
                  <div>                  
                  
                  <button type="button" onClick={filtrarPedidos} className="btn btn-secondary btn-cli" data-bs-dismiss="modal">Ativar</button>
                 
                  
                  {/* <button type="button" onClick={async()=> await gerarRelatorio()} className="btn btn-success btn-cli" data-bs-dismiss="modal">Imprimir</button> */}
                  </div>

                  

                </div>
              </div>
            </div>
          </div>
        
     

       { load === true?<Loading/>:null}   
       { sResult === 1?
         <div className="row" id='tabela-venda'>
        <table className="table table-hover table-striped">
            <thead>
            <tr>
                <th scope="col">DOCUMENTO</th>
                <th scope="col">DATA PEDIDO</th>
                <th scope="col">CLIENTE</th>
                <th scope="col">DATA ENTREGA</th>
                <th scope="col">STATUS</th>
                <th scope="col">AÇÃO</th>
                </tr>
            </thead>
            <tbody className="table-group-divider">
            {  
            encomendas.map((encomenda) => {
              const podeEmitir = isSameDay(encomenda.DATA);
                return <tr key={encomenda.ID}>
                       <td>{encomenda.DOCUMENTO}</td>
                       <td>{formatarDataBR(encomenda.DATA_PEDIDO)}</td>
                       <td>{encomenda.CLIENTE}</td>
                       <td>{formatarDataBR(encomenda.DATA_ENTREGA)}</td>
                       <td>{encomenda.STATUS_DESC}</td>
                       
                       
                       
                       
                    
                       
                       <td>
                         <div className="dropdown">
                            <button className="btn btn-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                              Ações
                            </button>
                            <ul className="dropdown-menu">
                              <li></li>
                              <li><a href={'/app/encomendas/novaEncomenda/'+encomenda.DOCUMENTO} className="dropdown-item"><i className="bi bi-search"></i>Visualizar</a></li>
                              <li><button className="dropdown-item" onClick={() => alterarStatusEncomenda(encomenda.ID, 2)}><i className="bi bi-check-circle"></i>Marcar como Entregue</button></li>
                              <li><button className="dropdown-item" onClick={async()=> await imprimirEntregaDetail(encomenda.DOCUMENTO)}><i className="bi bi-printer"></i>Imprimir</button></li>
                              <li><button className="dropdown-item" onClick={() => alterarStatusEncomenda(encomenda.ID, 3)}><i className="bi bi-x-circle"></i>Cancelar</button></li>
                             


                            </ul>
                         </div>
                      </td>
                      

                       </tr>
              } )}  
            </tbody>
          </table>  
          </div>        
          :<BuscaVazaia/>} 

            <div className="row mt-5 mb-5 align-items-center">
  {/* Input de seleção de página */}
  <div className="col-auto">
    <label className="form-label mb-1">
      Selecione uma página
    </label>

    <div className="input-group">
      <input
        type="number"
        min={1}
        max={totalPaginas}
        className="form-control"
        style={{ width: 120 }}
        value={nPag}
        onChange={(e) => setnPag(Number(e.target.value))}
      />
      <span className="input-group-text">
        / {totalPaginas}
      </span>
    </div>
  </div>

  {/* Paginação */}
  <div className="col">
    <SRI_pagination
      totalPage={totalPaginas}
      page={nPag}
      limit={10}
      siblings={1}
      onPageChange={handlePageChange}
    />
  </div>
</div>
        

          
         {
           confirmaEmissao ? 
           <SweetAlert
              success                         
              confirmBtnText="OK"
              confirmBtnBsStyle="success"
              title="Parabéns"
              onConfirm={() => setConfirmaEmissao(false)}                            
            >
              Nota Emitida com sucesso!
            </SweetAlert>:null
           
          }

          {
           erroEmissao ? 
           <SweetAlert
              danger
              confirmBtnText="OK"
              confirmBtnBsStyle="danger"
              title="Erro"
              onConfirm={() => setErroEmissao(false)}                            
            >
              {msgErro}
            </SweetAlert>:null
           
          }

          {
           cancelada ? 
           <SweetAlert
              success                         
              confirmBtnText="OK"
              confirmBtnBsStyle="success"
              title="Parabéns"
              onConfirm={() => setCancelada(false)}                            
            >
              {msgResponse}
            </SweetAlert>:null
           
          }

          {
           confirmaCancelamento ? 
           <SweetAlert
              warning
              showCancel
              confirmBtnText="Confirmar"
              cancelBtnText="Cancelar"
              confirmBtnBsStyle="danger"
              cancelBtnBsStyle="secondary"
              title="Confirma o cancelamento da NFe?"
              onConfirm={() => cencelaNFE(nPedidoSelecionado)}
              onCancel={() => setConfirmaCancelamento(false)}                            
            >
              Esta ação não poderá ser desfeita!
            </SweetAlert>:null
           
          }

          {
           confirmaCancelamentoVenda ? 
           <SweetAlert
              warning
              showCancel
              confirmBtnText="Confirmar"
              cancelBtnText="Cancelar"
              confirmBtnBsStyle="danger"
              cancelBtnBsStyle="secondary"
              title="Confirma o cancelamento da Venda?"
              onConfirm={() => cancelaVenda(codVendaSelecionado, documentoSelecionado)}
              onCancel={() => setConfirmaCancelamentoVenda(false)}                            
            >
              Esta ação não poderá ser desfeita!
            </SweetAlert>:null
           
          }

           {
                      selectRelatorio ? 
                      <SweetAlert 
                       info
                       title="Selecione o tipo de relatório!" 
                       showCloseButton
                       onConfirm={() => setSelectRelatorio(false)} 
                       onCancel={() => setSelectRelatorio(false)}
                       customButtons={
                      <React.Fragment>
                        <div className='row'>
                        <div className="d-flex justify-content-center col-12 mb-2"> 
                          <select className='form-select' onChange={(e) => setTipoRelatorio(e.target.value)}>
                            <option value={0}>Lista</option>
                            <option value={1}>Agrupado por Cupom</option>
                            <option value={2}>Produtos vendidos</option>
                            <option value={3}>Venda por finalizadora</option>
                          </select>
                        </div>
                        <div className="d-flex justify-content-end col-12">
                  <button className="btn btn-primary mr-1 btn-lg" onClick={async()=> await gerarRelatorio()}>PDF</button>
                  {/* <button className="btn btn-success mr-1 btn-lg" onClick={""}>Excel</button> */}
                 
                  
                  </div>
                  </div>
                      </React.Fragment>
                                       }
                         >
                       
                     </SweetAlert>:null
          
          
                    }
 
        

      </div>   
      <FooterBar/>    
    </div>
}


export default ListaEncomendas;